import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import {
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { CustomToggleButtonGroupProps as Props } from './types';

export const CustomToggleButtonGroup = memo(
  ({ className, items, open, size = 'small', onChange }: Props) => {
    const handleChange = (
      event: React.MouseEvent<HTMLElement>,
      newValue: string
    ) => {
      if (newValue) onChange(newValue);
    };

    return (
      <Styled.Wrapper
        className={classnames('JobTitleCategoryToggleButton', className)}
        sx={SX.root}
      >
        <ToggleButtonGroup
          onChange={handleChange}
          value={open}
          exclusive
          fullWidth
        >
          {items.map((item) => {
            return (
              <Tooltip
                key={item.name}
                title="Coming Soon"
                disableHoverListener={!item.comingSoon}
              >
                <Styled.TooltipChildWrapper>
                  <ToggleButton
                    disabled={item.disabled}
                    size={size}
                    value={item.value!}
                    key={item.key}
                  >
                    {item.icon && (
                      <Icon
                        name={item.icon}
                        size={18}
                        color={
                          item.value! === open ? item.iconColor : undefined
                        }
                      />
                    )}
                    <Typography variant="body3">{item.name}</Typography>
                  </ToggleButton>
                </Styled.TooltipChildWrapper>
              </Tooltip>
            );
          })}
        </ToggleButtonGroup>
      </Styled.Wrapper>
    );
  }
);

CustomToggleButtonGroup.displayName = 'CustomToggleButtonGroup';
